"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const get_1 = require("../get");
const real_type_of_1 = require("../real-type-of");
function render(template, data = {}) {
    if (typeof template !== 'string') {
        throw new TypeError(`Invalid template! Template should be a "string" but ${(0, real_type_of_1.realTypeOf)(template)} was given.`);
    }
    function replacer(chars) {
        return (match) => {
            match = match.slice(chars, -chars).trim();
            const value = (0, get_1.get)(data, match);
            return (value ?? '');
        };
    }
    return (template
        .replace(/\{\{\{([^}]+)\}\}\}/g, replacer(3))
        .replace(/\{\{([^}]+)\}\}/g, replacer(2)));
}
exports.render = render;
//# sourceMappingURL=placeholders.js.map